import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { reduxForm, change } from "redux-form";

import { tryLogin } from "../../actions/authActions";
import { sessionCheck } from "../../apis/backend";

import Form from "../CustomViews/Form";

const formName = "loginForm";
const LoginForm = reduxForm({ form: formName })(Form);

class Login extends React.Component {
    constructor(props) {
        super(props);

        this.state = { render: false };
    }

    componentDidMount() {
        sessionCheck(true)
        .then(() => this.setState({ render: true }))
        .catch(() => {});
    }

    onSubmit = (formValues, onLoginError) => this.props.tryLogin(formValues, error => {
        this.props.change(formName, "pass", "");
        onLoginError(error);
    });

    render() {
        if (this.state.render) {
            return (
                <React.Fragment>
                    <div className="ui secondary pointing menu">
                        <div className="ui container">
                            <h3 className="item">Zaloguj się</h3>
                        </div>
                    </div>
                    <div className="ui container">
                        <LoginForm onSubmit={this.onSubmit} label="Zaloguj" fields={[
                            { name: "email", type: "email", label: "Email:", placeholder: "Wpisz email...", autofocus: true },
                            { name: "pass", type: "password", label: "Hasło:", placeholder: "Wpisz hasło..." }
                        ]} />
                        <div className="ui divider"></div>
                        <Link to="/reset">
                            <p>Nie pamiętam hasła</p>
                        </Link>
                    </div>
                </React.Fragment>
            );
        }
        else return null;
    }
}

export default connect(null, { change, tryLogin })(Login);